const ENMapHierarchy = {
	"Deseja realmente excluir": "Do you really want to delete",
	"Erro ao excluir item da hierarquia": "Error deleting item from hierarchy",
	"Excluir Vínculo": "Delete Link",
	"Exclusão de Item da Hierarquia": "Hierarchy Item Deletion",
	"Item da hierarquia excluído com sucesso": "Hierarchy item successfully deleted",
	"Selecione ao menos um indicador": "Select at least one indicator",
	"Vincular indicadores": "Link indicators" 
};

export default ENMapHierarchy;
